import { flatMap, groupBy, uniqBy, values } from 'lodash';

export const locations = ({ containers, turns, snapshots = [] }) => {
  const locationsMap = uniqBy(
    [...turns, ...containers, ...snapshots],
    ({ location: { geohash } }) => geohash
  );

  const filteredLocationsMap = locationsMap
    .filter(({ location: { geohash } }) => geohash)
    .map(({ location }) => ({ location }));

  const preparedMarkers = flatMap(filteredLocationsMap, ({ location }) => ({
    location,
    snapshots: snapshots.filter(
      ({ location: { geohash } }) => geohash === location.geohash
    ),
    turns: turns.filter(
      ({ location: { geohash } }) => geohash === location.geohash
    ),
    containers: containers.filter(
      ({ location: { geohash } }) => geohash === location.geohash
    ),
  }));

  const groupedLocations = values(
    groupBy(preparedMarkers, ({ location: { geohash } }) => geohash)
  ).map((group) =>
    group.reduce((prev, { turns, containers, snapshots }) => ({
      location: prev.location,
      snapshots: [...prev.snapshots, ...snapshots],
      turns: [...prev.turns, ...turns],
      containers: [...prev.containers, ...containers],
    }))
  );

  return { preparedMarkers, groupedLocations };
};

// group container locations based on geohash
export const groupedContainerLocations = (containers) =>
  values(groupBy(containers, ({ location: { geohash } }) => geohash)).map(
    (group) => ({
      location: group[0].location,
      containers: group,
      lines: uniqBy(
        group.map((val) => val.line),
        ({ id }) => id
      ),
    })
  );

// Checking FlipAvailable in the organization locations
export const checkLocationFlipAvailability = (item, containerLocations) => {
  let isFlipAvailable = 'No';
  containerLocations.forEach((val) => {
    if (val.orgId === item.orgId) {
      if (val?.empty_locations && val.empty_locations.length > 0) {
        val.empty_locations.forEach((ele) => {
          if (ele.geohash === item.location.geohash) {
            isFlipAvailable = ele.details.isFlipYard ? 'Yes' : 'No';
          }
        });
      } else {
        isFlipAvailable = 'No';
      }
    }
  });

  return isFlipAvailable;
};

export const getloadsRequestedLocations = (commitments) => {
  const onboardedWithLocations = commitments.filter(
    (obj) => obj.location.geohash && obj.status === 'onboarded'
  );
  const uniqueGeohashes = new Set(
    onboardedWithLocations.map((obj) => obj.location.geohash)
  );
  return Array.from(uniqueGeohashes);
};
